/**
 * group Normalizr Schema
 */
import { schema } from 'normalizr';

import groupPerson from './groupPerson';

const group = new schema.Entity('groups', {
    people: [groupPerson]
});

export default group;
